import { render, staticRenderFns } from "./OrderVpn.vue?vue&type=template&id=319cfc0e&scoped=true&"
import script from "./OrderVpn.vue?vue&type=script&lang=js&"
export * from "./OrderVpn.vue?vue&type=script&lang=js&"
import style0 from "./OrderVpn.vue?vue&type=style&index=0&id=319cfc0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319cfc0e",
  null
  
)

export default component.exports